"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDetailedTimingFromMs = void 0;

const getDetailedTimingFromMs = duration => {
  const msInMinute = 60 * 1000;
  const minutes = Math.floor(duration / msInMinute).toString();
  const seconds = duration % msInMinute;
  const readableSeconds = String(seconds > 10 ? seconds : "0".concat(seconds)).slice(0, 2);
  return {
    minutes,
    seconds: readableSeconds
  };
};

exports.getDetailedTimingFromMs = getDetailedTimingFromMs;
//# sourceMappingURL=helpers.js.map